import React from "react";

export function PosterWinner() {
    return (
        <>
        
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        <center>
        <div class="right2">
<img src="https://diuy0t6boke2n.cloudfront.net/poster+contest/IMG_8862.jpg" alt="Poster"></img>
<img src="https://diuy0t6boke2n.cloudfront.net/poster+contest/IMG_8859.jpg" alt="Poster"></img>
<img src="https://diuy0t6boke2n.cloudfront.net/poster+contest/IMG_8864.jpg" alt="Poster"></img>


</div>
        </center>
        </>
    )
}